import * as moment from 'moment';
import { Moment } from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { history } from 'src';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import PrintButton from 'src/components/utils/PrintButton/PrintButton';
import { ApplicationState } from 'src/store';
import { getEvents, getEventsbyWeek } from 'src/store/events/actions';
import { CardEvent, IEventData } from 'src/store/events/types';
import { User } from 'src/store/user/types';
import { Week } from 'src/store/weeks/types';
import { DateArray, DateTranslations, getWeekDate, WeekDays } from 'src/utils/dateHelper';
import { EventListItem } from '../Event/Event';
import './WeekView.scss';
import { DailyPrint } from 'src/components/utils/Print/DailyPrint/DailyPrint';

interface PropsFromDispatch {
  getEvents: typeof getEventsbyWeek;
  getAllEvents: typeof getEvents;
}

interface PropsFromState {
  events: IEventData;
  loadingWeek: number;
  user: User;
}

interface Props {
  loading: boolean;
  week: Week;
  sectionTitle: string;
}

interface State {
  printing: number;
  loaded: number;
  images: number;
}

type AllProps = Props & PropsFromDispatch & PropsFromState;

class WeekView extends React.Component<AllProps, State> {
  currentPath: string;

  constructor(props: AllProps) {
    super(props);

    this.state = {
      printing: -1,
      loaded: 0,
      images: 0
    };

    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(mql => {
        if (!mql.matches) {
          this.afterPrint();
        }
      });
    }

    window.onafterprint = this.afterPrint;

    this.orderByWeekDate = this.orderByWeekDate.bind(this);
  }

  afterPrint = () => {
    console.log('Functionality to run after printing');
    this.onPrintFinished();
  };

  imageLoaded = (images: number) => {
    this.setState({ loaded: this.state.loaded + 1 }, () => {
      if (this.state.loaded === images) {
        window.print();
        this.setState({ printing: -1 });
      }
    });
  };

  onPrintFinished = () => {
    this.setState({ printing: -1 });
  };

  public componentDidMount() {
    this.currentPath = history.location.pathname;
    this.props.getEvents(this.props.week, this.props.sectionTitle);
  }

  onPrint = (weekdayNum: number) => {
    this.setState({ printing: weekdayNum });
  };

  public render() {
    const { startDate, id } = this.props.week;
    const { events, loadingWeek, loading } = this.props;
    return (
      <React.Fragment>
        {this.state.printing === -1 && (
          <div className="week_view">
            <div className="wrapper">
              <div className="weekdays">
                {DateArray.map((dateName: string) => {
                  const weekDayNum = WeekDays[dateName];
                  return (
                    <React.Fragment key={weekDayNum}>
                      <div className="weekday" key={weekDayNum}>
                        <div className="weekdayHeader">
                          <span>{DateTranslations[WeekDays[weekDayNum]]}</span>
                          <span>{getWeekDate(startDate, weekDayNum, 'DD.MM')}</span>
                          <PrintButton
                            onClick={this.onPrint.bind(this, weekDayNum)}
                            className="noAnim"
                            title="Tagesplan drucken"
                            style={{ height: '25px', right: '15px' }}
                          />
                        </div>
                        <div className="events">
                          <table>
                            <tbody>
                              {events.byWeekId[id] &&
                                events.byWeekId[id][weekDayNum] &&
                                this.renderEvents(
                                  events.byWeekId[id][weekDayNum],
                                  moment(startDate)
                                    .startOf('isoWeek')
                                    .add(weekDayNum, 'd')
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
                {loadingWeek === id && <LoadingSpinner pending={loading} />}
              </div>
            </div>
          </div>
        )}
        {this.state.printing !== -1 &&
          events.byWeekId[id] &&
          events.byWeekId[id][this.state.printing] && (
            <DailyPrint
              user={this.props.user}
              printingDone={this.onPrintFinished}
              headerText={`${DateTranslations[WeekDays[this.state.printing]]} ${getWeekDate(
                startDate,
                this.state.printing,
                'DD.MM.YYYY'
              )}`}
              events={events.byWeekId[id][this.state.printing].map(
                (eventId: number) => events.byId[eventId]
              )}
            />
          )}
      </React.Fragment>
    );
  }

  orderByWeekDate() {
    const ret: any = [];
    const bla = this.props.events.byWeekId[this.props.week.id];
    for (const dayNr in bla) {
      if (!isNaN(Number(dayNr))) {
        const events = bla[dayNr];
        console.log(events);
        for (const eventId of events) {
          const event = this.props.events.byId[eventId];
          ret.push(
            <tr key={dayNr}>
              <td>
                <Link to={this.currentPath + '/' + event.id}>{event.title}</Link>
              </td>
            </tr>
          );
        }
      }
    }
    return ret;
  }

  renderEvents = (eventIds: number[], weekDate: Moment) => {
    const ev: CardEvent[] = [];
    eventIds.forEach((evId: number) => {
      const event = this.props.events.byId[evId];
      if (moment(event.begins).format('DD.MM.YYYY') === moment(weekDate).format('DD.MM.YYYY')) {
        ev.push(event);
      }
    });

    ev.sort((a: CardEvent, b: CardEvent) => {
      const aDate = new Date(a.begins);
      const bDate = new Date(b.begins);
      return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
    });

    return ev.map((event: CardEvent, i: number) => {
      return (
        <tr key={i}>
          <td>
            <EventListItem
              currentPath={this.currentPath}
              event={event}
              key={i}
              user={this.props.user}
            />
          </td>
        </tr>
      );
    });
  };
}

const mapStateToProps = ({ auth, events }: ApplicationState) => ({
  events: events.data,
  user: auth.data,
  loading: events.loading,
  loadingWeek: events.loadingWeek
});

const mapDispatchToProps = (dispatch: any) => ({
  getEvents: (week: Week, sectionTitle: string) => dispatch(getEventsbyWeek(week, sectionTitle)),
  getAllEvents: () => dispatch(getEvents())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WeekView);



// WEBPACK FOOTER //
// ./src/components/Week/WeekView/WeekView.tsx